import { ListContactsFilter, PaginationParams } from "@dune/types";

export const contactsQueryKeys = {
	all: ["contacts"] as const,
	lists: () => [...contactsQueryKeys.all, "lists"] as const,
	list: (
		search: string,
		filter: ListContactsFilter,
		params: PaginationParams,
	) => [...contactsQueryKeys.lists(), search, filter, params] as const,
	details: () => [...contactsQueryKeys.all, "details"] as const,
	detail: (contactId: number) =>
		[...contactsQueryKeys.details(), contactId] as const,
};
